import { render, staticRenderFns } from "./ApproveOnServicesReservation.vue?vue&type=template&id=67f76f67&scoped=true&"
import script from "./ApproveOnServicesReservation.vue?vue&type=script&lang=js&"
export * from "./ApproveOnServicesReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f76f67",
  null
  
)

export default component.exports